<template>
    <rkm-row>
        <rkm-col cols="4">
            <rkm-form-input
                :validations="validations.numero"
                label="Número"
                v-model="model.documentos.tituloEleitor.numero"
                uppercase
                @blur="numeroPadLeft"
            />
        </rkm-col>

        <rkm-col cols="4">
            <rkm-form-input
                :validations="validations.zona"
                label="Zona"
                uppercase
                v-model="model.documentos.tituloEleitor.zona"
                :disabled="!model.documentos.tituloEleitor.numero"
                @blur="zonaPadLeft"
            />
        </rkm-col>

        <rkm-col cols="4">
            <rkm-form-input
                :validations="validations.secao"
                label="Seção"
                uppercase
                v-model="model.documentos.tituloEleitor.secao"
                :disabled="!model.documentos.tituloEleitor.numero"
                @blur="secaoPadLeft"
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
export default {
    props: {
        model: { type: Object, required: true },
    },
    computed: {
        validations() {

            return {
                numero: {
                    min: 9,
                    max: 13
                },
                zona: {
                    required: !!this.model.documentos.tituloEleitor.numero,
                    min: 3,
                    max: 4
                },
                secao: {
                    required: !!this.model.documentos.tituloEleitor.numero,
                    min: 4,
                    max: 4
                }
            }
        }
    },
    watch: {
        'model.documentos.tituloEleitor.numero': function (numero) {

            if (!numero) {

                this.model.documentos.tituloEleitor.zona = ''
                this.model.documentos.tituloEleitor.secao = ''
            }
        }
    },
    methods: {
        numeroPadLeft() {

            if (this.model.documentos.tituloEleitor.numero == '') return this.model.documentos.tituloEleitor.numero

            return this.model.documentos.tituloEleitor.numero = this.model.documentos.tituloEleitor.numero.padStart(13, '0')
        },
        zonaPadLeft() {

            if (this.model.documentos.tituloEleitor.zona == '') return this.model.documentos.tituloEleitor.zona

            return this.model.documentos.tituloEleitor.zona = this.model.documentos.tituloEleitor.zona.padStart(4, '0')
        },
        secaoPadLeft() {

            if (this.model.documentos.tituloEleitor.secao == '') return this.model.documentos.tituloEleitor.secao

            return this.model.documentos.tituloEleitor.secao = this.model.documentos.tituloEleitor.secao.padStart(4, '0')
        },
    },
}
</script>